/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopropertyEligibilityStatus } from './CopropertyEligibilityStatus';
import {
    CopropertyEligibilityStatusFromJSON,
    CopropertyEligibilityStatusFromJSONTyped,
    CopropertyEligibilityStatusToJSON,
    CopropertyEligibilityStatusToJSONTyped,
} from './CopropertyEligibilityStatus';

/**
 * MRI eligibility verdict of a coproperty (sub-step or global, depending on the endpoint).
 * @export
 * @interface CopropertyEligibilityDto
 */
export interface CopropertyEligibilityDto {
    /**
     * 
     * @type {CopropertyEligibilityStatus}
     * @memberof CopropertyEligibilityDto
     */
    status: CopropertyEligibilityStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopropertyEligibilityDto
     */
    reasons: Array<string>;
}



/**
 * Check if a given object implements the CopropertyEligibilityDto interface.
 */
export function instanceOfCopropertyEligibilityDto(value: object): value is CopropertyEligibilityDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function CopropertyEligibilityDtoFromJSON(json: any): CopropertyEligibilityDto {
    return CopropertyEligibilityDtoFromJSONTyped(json, false);
}

export function CopropertyEligibilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyEligibilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': CopropertyEligibilityStatusFromJSON(json['status']),
        'reasons': json['reasons'],
    };
}

export function CopropertyEligibilityDtoToJSON(json: any): CopropertyEligibilityDto {
    return CopropertyEligibilityDtoToJSONTyped(json, false);
}

export function CopropertyEligibilityDtoToJSONTyped(value?: CopropertyEligibilityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': CopropertyEligibilityStatusToJSON(value['status']),
        'reasons': value['reasons'],
    };
}

